import { BaseballLineupPosition, IApiLineupPlayer, iPlayerToApiPlayerWithDexterityMap } from '@trackman/baseball-shared-components';
import { ApiLineupDraggablePlayer } from 'interfaces/team/ApiLineupDraggablePlayer';
import { ILineupEntry } from 'interfaces/team/ILineupEntry';
import { IPlayer } from 'interfaces/team/IPlayer';
import { v1 as uuid } from 'uuid';

export const lineupEntryToApiLineupPlayerMap = (lineupEntry: ILineupEntry): ApiLineupDraggablePlayer => {
  return playerToApiLineupPlayerMap(lineupEntry.player!, lineupEntry.position, lineupEntry.order);
};

export const apiLineupPlayerToLineupEntryMap = (player: IApiLineupPlayer): ILineupEntry => {
  const id = uuid();

  return {
    id: id,
    order: player.battingOrder,
    player: apiLineupPlayerToPlayerMap(player),
    position: player.position,
    isEnabled: true,
    name: id,
  };
};

export const playerToApiLineupPlayerMap = (
  player: IPlayer,
  position?: BaseballLineupPosition,
  battingOrder?: number
): ApiLineupDraggablePlayer => {
  return {
    id: player.id,
    battingHandedness: player.dexterity.bats,
    pitchingHandedness: player.dexterity.throws,
    nameRef: playerToPlayerFullNameMap(player),
    position: position || BaseballLineupPosition.Undefined,
    battingOrder,
    isPlaceholder: !!player.isPlaceholder,
    foreignIds: player.foreignIds,
    jerseyNumber: player.jerseyNumber ? player.jerseyNumber : '',
    isEnabled: true,
    name: player.id,
    height: player.height,
    strikeZoneBottom: player.strikeZoneBottom,
    strikeZoneTop: player.strikeZoneTop,
    birthDate: player.birthDate,
    ids: player.ids
  };
};

export const apiLineupPlayerToPlayerMap = (lineupPlayer: IApiLineupPlayer): IPlayer => {
  return {
    id: lineupPlayer.id,
    dexterity: {
      bats: lineupPlayer.battingHandedness,
      throws: lineupPlayer.pitchingHandedness,
    },
    firstName: lineupPlayer.nameRef.split(',')[1].trim(),
    lastName: lineupPlayer.nameRef.split(',')[0].trim(),
    isPlaceholder: lineupPlayer.isPlaceholder,
    foreignIds: lineupPlayer.foreignIds,
    jerseyNumber: lineupPlayer.jerseyNumber,
    positions: [],
    height: lineupPlayer.height,
    strikeZoneBottom: lineupPlayer.strikeZoneBottom,
    strikeZoneTop: lineupPlayer.strikeZoneTop,
    birthDate: lineupPlayer.birthDate,
    ids: lineupPlayer.ids
  };
};
export const playerToPlayerFullNameMap = (player: IPlayer) => `${player.lastName}, ${player.firstName}`;

export const playerToReviewPlayerMap = (player: IPlayer | undefined, teamName: string) => {
  const apiPlayer = iPlayerToApiPlayerWithDexterityMap(player);
  return { ...apiPlayer, teamName, name: apiPlayer.nameRef };
};
